// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"615bbe4e","172":"8f2e9e76","448":"deccad90","544":"7299c264","876":"19730886"}[chunkId] + ".chunk.js";
};